import React from 'react';

const Settings = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Paramètres</h1>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4">
          <div className="space-y-4">
            <div>
              <h2 className="text-lg font-semibold mb-2">Paramètres généraux</h2>
              <p className="text-gray-500">Les paramètres seront disponibles prochainement</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings; 